/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ViewId } from "../../commons/types/ViewId";
import { SheetId } from "../../commons/types/SheetId";
import { ViewConfig } from "./ViewConfig";
export const View = core.serialization.object({
    id: ViewId,
    sheetId: SheetId,
    name: core.serialization.string(),
    config: ViewConfig,
    createdBy: core.serialization.string(),
});
